<template>
    <div class="col-sm-12 nopads">
      <div class="content-header-container"
           v-bind:style="{ backgroundImage: 'url(' + getBackground() + ')' }">
        <transition name="fade">
          <div v-if="!backgroundImage && !photo" class="header-img-overlay">
          </div>
        </transition>
        <span v-if="orgUpdate" class="header-title z-10">{{ orgUpdate.name }}</span>
      </div>
        <b-form>
            <h2 class="m-3">
                {{ isEditing() ? $t('organization.edit'):$t('organization.add') }}
                <img v-if="photo"
                     :src="getUrl()"
                     width="50px"
                     height="50px"
                     class="float-right">
            </h2>
            <div class="col-sm-12 form-data">

                <!--Name-->
                <b-form-group
                        class="title"
                        label-for="name">
                  <span class="span-title">
                   {{ $t('organization.name') }}
                  </span>
                    <b-form-input
                            id="name"
                            v-model="orgUpdate.name"
                            type="text"
                            size="mb"
                    />
                </b-form-group>

                <!--Identification code-->
                <b-form-group
                        class="title"
                        label-for="identification_code">
                  <span class="span-title">
                   {{ $t('organization.identification_code') }}
                  </span>
                    <b-form-input
                            id="identification_code"
                            v-model="orgUpdate.identificationCode"
                            type="text"
                            size="mb"
                    />
                </b-form-group>

                <!--Fund raising license -->
                <b-form-group
                        class="title"
                        label-for="name">
                  <span class="span-title">
                   {{ $t('campaign.license') }}
                  </span>
                    <b-form-input
                            id="name"
                            v-model="orgUpdate.license"
                            type="text"
                            size="mb"
                    />
                </b-form-group>

                <!-- Category -->
                <b-form-group
                        class="title"
                        label-for="category">
                  <span class="span-title">
                   {{ $t('categories.title') }}
                  </span>
                    <b-form-select
                            id="category"
                            v-model="orgUpdate.category"
                            :options="categories"
                            size="mb"
                    >
                    </b-form-select>
                </b-form-group>

                <!--Description-->
                <b-form-group
                        class="title"
                        label-for="description">
                  <span class="span-title">
                   {{ $t('organization.description') }}
                  </span>
                    <b-form-input
                            id="description"
                            v-model="orgUpdate.description"
                            type="text"
                            size="mb"
                    />
                </b-form-group>

                <!--Address-->
                <!--Street address-->
                <b-form-group
                        class="title"
                        label-for="street_address">
                  <span class="span-title">
                   {{ $t('organization.street_address') }}
                  </span>
                    <b-form-input
                            id="street_address"
                            v-model="orgUpdate.address.streetAddress"
                            type="text"
                            size="mb"
                    />
                </b-form-group>

                <!--postal-->
                <b-form-group
                        class="title"
                        label-for="postal">
                  <span class="span-title">
                   {{ $t('organization.postal') }}
                  </span>
                    <b-form-input
                            id="postal"
                            v-model="orgUpdate.address.postal"
                            type="text"
                            size="mb"
                    />
                </b-form-group>

                <!--city-->
                <b-form-group
                        class="title"
                        label-for="city">
                  <span class="span-title">
                   {{ $t('organization.city') }}
                  </span>
                    <b-form-input
                            id="city"
                            v-model="orgUpdate.address.city"
                            type="text"
                            size="mb"
                    />
                </b-form-group>

                <!--country-->
                <b-form-group
                        class="title"
                        label-for="country">
                  <span class="span-title">
                   {{ $t('organization.country') }}
                  </span>
                    <b-form-input
                            id="country"
                            v-model="orgUpdate.address.country"
                            type="text"
                            size="mb"
                    />
                </b-form-group>

                <!--phone-->
                <b-form-group
                        class="title"
                        label-for="phone">
                  <span class="span-title">
                   {{ $t('organization.phone') }}
                  </span>
                    <b-form-input
                            id="phone"
                            v-model="orgUpdate.phone"
                            type="text"
                            size="mb"
                    />
                </b-form-group>
                <span class="span-title">{{$t("organization.commission")}}</span>
                <b-form-group>
                    <b-form-input
                            id="commission"
                            v-model="orgUpdate.commission"
                            type="number"
                            number
                            step="0.1"
                            min="0"
                            max="100"
                    />
                </b-form-group>

                <b-form-group
                        class="title"
                        label-for="organization">
                  <span class="span-title">
                   {{ $t('team.active') }}
                  </span>
                    <b-form-checkbox
                            id="active"
                            v-model="orgUpdate.active"
                            name="active"
                    >
                        {{ $t('organization.active_desc') }}
                    </b-form-checkbox>
                </b-form-group>


              <fair-image-picker
                  :label="$t('team.photo')"
                  v-model="photo"/>

                <div class="col-sm-12 button-container">
                    <b-button
                            class="fair-button"
                            variant="danger"
                            :disabled="loading"
                            @click.stop="cancel"
                    >
                          <span>
                              {{ $t('common.cancel') }}
                          </span>
                    </b-button>

                    <b-button
                            class="fair-button"
                            variant="success"
                            :disabled="loading"
                            @click.stop="submitOrganization"
                    >
                          <span>
                              {{ $t('common.save') }}
                          </span>
                    </b-button>
                </div>
            </div>
        </b-form>

        <div
                v-if="loading"
                id="loader"
                class="spinner"
        />
    </div>
</template>

<script>
    import FairApi from '../../modules/api'
    import FairImagePicker from "@/components/FairImagePicker";

    export default {
      name: 'organization-editor',
      components: {FairImagePicker},
      props: {
            organizationId: {
                type: [String, Number],
                default: null
            },
            photoUrl: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                loading: false,
                orgUpdate: this.newOrganization(),
                photo: null,
                backgroundImage: null,
                categories: [
                    { value: null, text: this.$t('categories.select_category'), disabled: true },
                    { value: 1, text: this.$t('categories.1') },
                    { value: 2, text: this.$t('categories.2') },
                    { value: 3, text: this.$t('categories.schools') },
                    { value: 4, text: this.$t('categories.4') }
                ]
            }
        },
        created() {
            if (this.organizationId) {
                this.fetchOrganization()
            }
        },
        methods: {
            getBackground: function () {
              if (!this.photo) {
                return this.backgroundImage
              } else {
                return this.getUrl(this.photo)
              }
            },

            fetchOrganization: function () {
                this.loading = true
                FairApi.get(FairApi.organization(this.organizationId), this.fetchOrganizationSuccess,
                    this.fetchOrganizationFailed)
            },

            fetchOrganizationSuccess: function (response) {
                this.orgUpdate = response
                if (!this.orgUpdate.category) {
                    this.orgUpdate.category = null
                }
                this.loading = false
                this.fetchBackgroundImage()
            },

            fetchOrganizationFailed: function () {
                this.loading = false
                this.orgUpdate = this.newOrganization()
            },

            getUrl: function () {
                URL.revokeObjectURL(this.photo)
                return (this.photo) ? URL.createObjectURL(this.photo) : ""
            },

            fetchBackgroundImage: function () {
              if (this.orgUpdate.photo) {
                 FairApi.get(FairApi.photo(this.orgUpdate.photo.id), this.successImage, this.failImage)
              }
            },

            successImage: function (response) {
              this.backgroundImage = response
              this.loading = false
            },

            failImage() {
              this.loading = false
            },

            newOrganization: function () {
                return {
                    id: null,
                    name: '',
                    identificationCode: '',
                    description: null,
                    commission: 0,
                    phone: null,
                    category: null,
                    license: null,
                    photo: null,
                    active: true,
                    address: {
                        id: null,
                        streetAddress: '',
                        postal: '',
                        city: null,
                        country: null
                    }
                }
            },
            submitOrganization: function () {
                let json = this.setDefaultValues(this.orgUpdate)
                if (json !== undefined) {
                  this.loading = true
                  let formData = new FormData()
                  if (this.photo) {
                    formData.append('photo', this.photo)
                  }
                  if (this.isEditing()) {
                    FairApi.postWithFile(FairApi.organizationUpdate(), json, formData, this.success, this.fail)
                  } else {
                    FairApi.postWithFile(FairApi.organization(), json, formData, this.success, this.fail)
                  }
                }
            },
            cancel: function () {
                this.$store.commit('storeStripeAuthOrganization', null)
                this.$emit('close')
            },
            setDefaultValues: function (orgUpdate) {
                let org = JSON.parse(JSON.stringify(orgUpdate))
                if (!org.name) {
                    this.$emit('alert', this.$t('organization.invalid_name'))
                    return undefined
                }
                if (!org.identificationCode) {
                    this.$emit('alert', this.$t('organization.invalid_identification_code'))
                    return undefined
                }
                if (!org.category) {
                    this.$emit('alert', this.$t('organization.invalid_category'))
                    return undefined
                }
                if(!org.photo && !this.photo) {
                    this.$emit('alert', this.$t('organization.no_picture'))
                    return undefined
                }
                return org
            },

            success: function () {
                this.closeAndUpdate()
            },

            closeAndUpdate: function () {
                this.$emit('closeAndUpdate')
                this.loading = false
            },

            fail: function (response) {
                this.loading = false
                if (response.status === 409) {
                    this.$emit('alert', this.$t('organization.duplicate_identification_code'))
                } else {
                    this.$emit('alert', this.$t('common.alert_update_failed'))
                }
            },

            isEditing: function () {
                return this.orgUpdate && this.orgUpdate.id
            },

            reload() {
                window.location.href = window.location.href.split("?")[0]
            },

        }
    }
</script>